<template>
	<div
		v-show="isOpen"
		class="advanced-options expanded"
	>
		<div class="adv-option-groups">
			<div class="row no-gutters">
				<div class="col-12 px-2">
					<p class="desc">Input known size of primary storage and heat pump capacity then size supplemental heating capacity. Supplemental heating equipment includes natural gas, electric resistance, and other heating equipment used to provide trim heating for a heat pump system.</p>
				</div>
			</div>

			<div class="row no-gutters pb-4">
				<div class="col-4 px-2">
					<div class="field-wrap dual-fuel-field">
						<label>Primary Storage (Gallons)</label>

						<input
							type="number"
							v-model="formData.primaryStorageVol_G"
							step="any"
							min="0"
							:required="isDualFuelSchematic"
						>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>

				<div class="col-4 px-2">
					<div class="field-wrap dual-fuel-field">
						<label>Primary Heating Capacity (kBTU/hr)</label>

						<input
							type="number"
							v-model="formData.primaryHeatingCap_kBTUh"
							step="any"
							min="0"
							:required="isDualFuelSchematic"
						>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>
			</div>

			<div class="row justify-content-between no-gutters">
				<div class="col-9 col-xxl-8">
					<div class="row no-gutters">
						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'sprtp_series'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'sprtp_series',
									}"
									data-value="sprtp_series"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-singlepassRTPinseries.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Single Pass Return to Primary with Supplemental Heating in Series</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'mprtp_series'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'mprtp_series',
									}"
									data-value="mprtp_series"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-multipassRTPinseries.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Multi Pass Return to Primary with Supplemental Heating in Series</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'gas_swingtank'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'gas_swingtank',
									}"
									data-value="gas_swingtank"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-swingtankHighCapacity.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>High Capacity Swing Tank</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2 mt-3">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'gas_parallel'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'gas_parallel',
									}"
									data-value="gas_parallel"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-singlepassRTPinparallel.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Single Pass Return to Primary with Supplemental Heating in Parallel</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'DualFuelOpts',

	props: {
		isOpen: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		formData,
	}),

	computed: {
		isDualFuelSchematic () {
			return ['sprtp_series', 'mprtp_series', 'gas_swingtank', 'gas_parallel'].includes(formData.schematic)
		},
	},
}
</script>

<style scoped>
.dual-fuel-field label {
	display: flex;
	align-items: flex-end;
	min-height: 2.2em;
}
</style>
